import { render, staticRenderFns } from "./FormBuilderTabs.vue?vue&type=template&id=7ae6c9a8&scoped=true"
import script from "./FormBuilderTabs.vue?vue&type=script&lang=js"
export * from "./FormBuilderTabs.vue?vue&type=script&lang=js"
import style0 from "./FormBuilderTabs.vue?vue&type=style&index=0&id=7ae6c9a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ae6c9a8",
  null
  
)

export default component.exports